module.exports = require("worker_threads");